import { Controller } from "@hotwired/stimulus";

// Attaches in two places: on the <dialog> itself (whose scope provides the
// close action for the footer buttons), and on any external trigger, which
// must carry its OWN controller instance — Stimulus actions never reach a
// controller outside their scope:
//   data-controller="dialog" data-action="dialog#open" data-dialog-id-param="confirm"
// open() resolves the target via the id action param, falling back to this.element.
export default class extends Controller {
  open(event) {
    const id = event?.params?.id;
    const el = id ? document.getElementById(id) : this.element;
    el.showModal();
  }

  close() {
    this.element.close();
  }
}
